import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonMaterialComponentsModule } from '@quorum/common-material-components';
import { TextMaskModule } from 'angular2-text-mask';
import { NgPipesModule } from 'ngx-pipes';
import { CommonPipesModule } from '@quorum/common-pipes';
// eslint-disable-next-line max-len
import { AppointmentCaseCreateFormComponent } from './appointment-case-create-form/appointment-case-create-form.component';
import { AppointmentCaseEditFormComponent } from './appointment-case-edit-form/appointment-case-edit-form.component';
import { AppointmentCaseListComponent } from './appointment-case-list/appointment-case-list.component';
import { CreateServiceAppointmentComponent } from './create-service-appointment/create-service-appointment.component';
import { ServiceAppointmentLargeComponent } from './service-appointment-large/service-appointment-large.component';
import { ServiceAppointmentMediumComponent } from './service-appointment-medium/service-appointment-medium.component';
import { ServiceAppointmentFormComponent } from './service-appointment-form/service-appointment-form.component';
import { ServiceGroupSelectionComponent } from './service-group-selection/service-group-selection.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ShaComponentsNgUiModule } from 'libs/sha-components-ng-ui/src/lib/sha-components-ng-ui.module';
import { AppointmentCardComponent } from './appointment-card/appointment-card.component';
import { AppointmentCardLineItemsDialogComponent } from './appointment-card-line-items-dialog/appointment-card-line-items-dialog.component';
import { AppointmentCaseCreateEditDialogComponent } from './appointment-case-create-edit-dialog/appointment-case-create-edit-dialog.component';
import { ShowLineItemServicesDialogComponent } from './show-line-item-services-dialog/show-line-item-services-dialog.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonMaterialComponentsModule,
    FlexLayoutModule,
    NgPipesModule,
    TextMaskModule,
    CommonPipesModule,
    ScrollingModule,
    ShaComponentsNgUiModule,
  ],
  declarations: [
    ServiceAppointmentFormComponent,
    ServiceAppointmentMediumComponent,
    ServiceAppointmentLargeComponent,
    AppointmentCaseListComponent,
    AppointmentCaseEditFormComponent,
    CreateServiceAppointmentComponent,
    AppointmentCaseCreateFormComponent,
    ServiceGroupSelectionComponent,
    AppointmentCardComponent,
    AppointmentCardLineItemsDialogComponent,
    AppointmentCaseCreateEditDialogComponent,
    ShowLineItemServicesDialogComponent,
  ],
  exports: [
    ServiceAppointmentFormComponent,
    ServiceAppointmentMediumComponent,
    ServiceAppointmentLargeComponent,
    AppointmentCaseListComponent,
    AppointmentCaseEditFormComponent,
    CreateServiceAppointmentComponent,
    AppointmentCaseCreateFormComponent,
    ServiceGroupSelectionComponent,
    AppointmentCardComponent,
    AppointmentCaseCreateEditDialogComponent,
    ShowLineItemServicesDialogComponent,
  ],
  entryComponents: [ServiceGroupSelectionComponent, AppointmentCaseCreateEditDialogComponent],
})
export class ShaServiceAppointmentsNgUiModule {}
